import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Task_$reflection, Course_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, int32_type, record_type, option_type, array_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Dialog as Dialog_1, CourseDialogMode, CourseChange_$reflection, CourseDialogMode_$reflection } from "../Course/CourseDialog.jsx";
import { sortBy, append, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Task, toastServerError, Course } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Body1, Title3, Caption1, Text as Text$, MenuItem, MenuList, MenuPopover, MenuTrigger, Menu, Caption2, Subtitle2, CardHeader, CardPreview, Card, DialogSurface, DialogBody, Button, DialogActions, Checkbox, Body1Strong, tokens, DialogContent, DialogTitle, Dialog } from "@fluentui/react-components";
import { comparePrimitives, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { AddRegular, MoreHorizontalRegular, BookOpenRegular, DeleteRegular, DismissRegular, WarningFilled } from "@fluentui/react-icons";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { map as map_1, empty, singleton as singleton_1, append as append_1, delay, toList, take, length } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { unwrap, orElse } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";

class Model extends Record {
    constructor(AllCourses, AllTasks, DialogMode, PendingDelete) {
        super();
        this.AllCourses = AllCourses;
        this.AllTasks = AllTasks;
        this.DialogMode = DialogMode;
        this.PendingDelete = PendingDelete;
    }
}

function Model_$reflection() {
    return record_type("EditCourse.Model", [], Model, () => [["AllCourses", array_type(Course_$reflection())], ["AllTasks", array_type(Task_$reflection())], ["DialogMode", option_type(CourseDialogMode_$reflection())], ["PendingDelete", option_type(Course_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetAllCourses", "SetAllTasks", "OpenDialog", "CloseDialog", "ApplyChange", "RequestDelete", "RemoveCourse"];
    }
}

function Msg_$reflection() {
    return union_type("EditCourse.Msg", [], Msg, () => [[["Item", array_type(Course_$reflection())]], [["Item", array_type(Task_$reflection())]], [["Item", CourseDialogMode_$reflection()]], [], [["Item", CourseChange_$reflection()]], [["Item", option_type(Course_$reflection())]], [["Item", int32_type]]]);
}

function init() {
    return new Model([], [], undefined, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.AllCourses, msg.fields[0], model.DialogMode, model.PendingDelete);
        case 2:
            return new Model(model.AllCourses, model.AllTasks, msg.fields[0], model.PendingDelete);
        case 3:
            return new Model(model.AllCourses, model.AllTasks, undefined, model.PendingDelete);
        case 4:
            if (msg.fields[0].tag === 1) {
                return new Model(map((existing) => {
                    if (existing.Id === msg.fields[0].fields[0].Id) {
                        return msg.fields[0].fields[0];
                    }
                    else {
                        return existing;
                    }
                }, model.AllCourses), model.AllTasks, model.DialogMode, model.PendingDelete);
            }
            else {
                return new Model(append([msg.fields[0].fields[0]], model.AllCourses), model.AllTasks, model.DialogMode, model.PendingDelete);
            }
        case 5:
            return new Model(model.AllCourses, model.AllTasks, model.DialogMode, msg.fields[0]);
        case 6:
            return new Model(model.AllCourses.filter((c_3) => (c_3.Id !== msg.fields[0])), model.AllTasks, model.DialogMode, undefined);
        default:
            return new Model(msg.fields[0], model.AllTasks, model.DialogMode, model.PendingDelete);
    }
}

function getAllCourses(dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 0) {
            dispatch(new Msg(0, [res.fields[0]]));
        }
        else {
            errorToast(setCtx, "getCoursesError", "Kunne ikke hente kurs", "Noe gikk galt", undefined);
        }
    }, startAsPromise(Course.GetAllCourses()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function getTasks(dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 0) {
            dispatch(new Msg(1, [res.fields[0]]));
        }
        else {
            errorToast(setCtx, "getTasksError", "Kunne ikke hente oppgaver", "Noe gikk galt", undefined);
        }
    }, startAsPromise(Task.GetAllTasks()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function deleteCourse(courseId, onSuccess, setCtx) {
    const pr = tap((res) => {
        let matchResult;
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1:
                case 2: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 1;
            }
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0: {
                onSuccess();
                successToast(setCtx, "deleteCourseSuccess", "Kursmal ble slettet", "");
                break;
            }
            case 1: {
                errorToast(setCtx, "deleteCourseNotFound", "Kunne ikke slette", "Kursmalen ble ikke funnet", undefined);
                break;
            }
            case 2: {
                errorToast(setCtx, "deleteCourseRelations", "Kunne ikke slette", "Kursmalen er fortsatt i bruk", undefined);
                break;
            }
        }
    }, startAsPromise(Course.DeleteCourse(courseId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function DeleteConfirmDialog(deleteConfirmDialogInputProps) {
    let elems_3, props_34, props_32, el, el_8, elems, el_2, el_4, el_6, el_14, elems_1, el_12, el_10, el_20, elems_2, el_18, el_16, name, name_2, elemsToUse;
    const dispatch = deleteConfirmDialogInputProps.dispatch;
    const course = deleteConfirmDialogInputProps.course;
    const patternInput = useCtx();
    const patternInput_1 = reactApi.useState(false);
    const setHasConfirmed = patternInput_1[1];
    const hasConfirmed = patternInput_1[0];
    const el_22 = Dialog;
    return createElement(el_22, createObj(ofArray([["open", true], ["modalType", "modal"], ["onOpenChange", (_arg, value_1_1) => {
        if (!value_1_1.open) {
            setHasConfirmed(false);
            dispatch(new Msg(5, [undefined]));
        }
    }], (elems_3 = [(props_34 = singleton((props_32 = ofArray([(el = DialogTitle, createElement(el, {
        children: "Slett kursmal",
    })), (el_8 = DialogContent, createElement(el_8, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_2 = WarningFilled, createElement(el_2, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_4 = Body1Strong, createElement(el_4, {
        style: {
            textAlign: "center",
        },
        children: `Er du sikker på at du vil slette "${course.Name}"? Det vil ikke være mulig å angre denne handlingen.`,
    })), (el_6 = Checkbox, createElement(el_6, {
        label: "Ja, jeg er sikker",
        checked: hasConfirmed,
        onChange: (_arg_1, c) => {
            setHasConfirmed(Checkbox_toBool(c));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_14 = DialogActions, createElement(el_14, createObj(ofArray([["position", "start"], (elems_1 = [(el_12 = Button, createElement(el_12, {
        icon: (el_10 = DismissRegular, createElement(el_10, {})),
        children: "Avbryt",
        onClick: (_arg_2) => {
            dispatch(new Msg(5, [undefined]));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "end"], (elems_2 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DeleteRegular, createElement(el_16, {})),
        appearance: "primary",
        children: "Slett",
        disabled: !hasConfirmed,
        onClick: (_arg_3) => {
            deleteCourse(course.Id, () => {
                dispatch(new Msg(6, [course.Id]));
            }, patternInput[1]);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_32)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_34)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function CourseCard(courseCardInputProps) {
    let elems_6;
    const dispatch = courseCardInputProps.dispatch;
    const course = courseCardInputProps.course;
    const imageUrl = orElse(course.ThumbnailUrl, course.ImageUrl);
    const taskCount = course.Tasks.length | 0;
    const taskLabel = (taskCount === 1) ? "oppgave" : "oppgaver";
    const el_30 = Card;
    return createElement(el_30, createObj(ofArray([["appearance", "filled"], ["style", {
        cursor: "pointer",
        minWidth: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    }], ["onClick", (_arg) => {
        dispatch(new Msg(2, [new CourseDialogMode(1, [course])]));
    }], (elems_6 = toList(delay(() => {
        let el_2, elems;
        return append_1(singleton_1((el_2 = CardPreview, createElement(el_2, createObj(ofArray([["style", {
            height: 110 + "px",
            backgroundColor: tokens.colorNeutralBackground3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
        }], (elems = toList(delay(() => {
            let url, url_1, el;
            return (imageUrl != null) ? (((url = imageUrl, url.length > 0)) ? ((url_1 = imageUrl, singleton_1(createElement("img", {
                src: url_1,
                alt: course.Name,
                style: {
                    width: 100 + "%",
                    height: 100 + "%",
                    objectFit: "cover",
                    display: "block",
                },
            })))) : singleton_1((el = BookOpenRegular, createElement(el, {
                fontSize: 32,
                primaryFill: tokens.colorNeutralForeground3,
            })))) : singleton_1((el = BookOpenRegular, createElement(el, {
                fontSize: 32,
                primaryFill: tokens.colorNeutralForeground3,
            })));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))), delay(() => {
            let el_26, el_4, el_6, el_24, elems_4, el_12, el_10, el_8, el_22, elems_3, el_20, elems_2, el_18, el_14, elems_1, el_16, elemsToUse;
            return append_1(singleton_1((el_26 = CardHeader, createElement(el_26, {
                header: (el_4 = Subtitle2, createElement(el_4, {
                    style: {
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    },
                    children: course.Name,
                })),
                description: (el_6 = Caption2, createElement(el_6, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                        display: "block",
                    },
                    children: `${taskCount} ${taskLabel}`,
                })),
                action: (el_24 = Menu, createElement(el_24, createObj(singleton((elems_4 = [(el_12 = MenuTrigger, createElement(el_12, {
                    disableButtonEnhancement: true,
                    children: (el_10 = Button, createElement(el_10, {
                        appearance: "transparent",
                        icon: (el_8 = MoreHorizontalRegular, createElement(el_8, {})),
                        onClick: (e) => {
                            e.stopPropagation();
                        },
                    })),
                })), (el_22 = MenuPopover, createElement(el_22, createObj(singleton((elems_3 = [(el_20 = MenuList, createElement(el_20, createObj(singleton((elems_2 = [(el_18 = MenuItem, createElement(el_18, createObj(ofArray([["icon", (el_14 = DeleteRegular, createElement(el_14, {}))], ["onClick", (e_1) => {
                    e_1.stopPropagation();
                    dispatch(new Msg(5, [course]));
                }], (elems_1 = [(el_16 = Text$, createElement(el_16, {
                    children: "Slett kurs",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])))))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)])))))),
            }))), delay(() => {
                let elems_5, el_28;
                return (course.Summary.length > 0) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                    padding: ((((((0 + "px ") + 12) + "px ") + 12) + "px ") + 12) + "px",
                }], (elems_5 = [(el_28 = Caption1, createElement(el_28, {
                    style: {
                        color: tokens.colorNeutralForeground2,
                        display: "-webkit-box",
                        overflow: "hidden",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                    },
                    children: course.Summary,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty();
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])));
}

export function EditCourseView() {
    let elems_3;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    useEffectOnce(() => {
        getAllCourses(dispatch, setCtx);
        getTasks(dispatch, setCtx);
    });
    const cardMinWidth = (screenSize.tag === 0) ? "240px" : ((screenSize.tag === 1) ? "240px" : "280px");
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 16 + "px ",
    }], (elems_3 = toList(delay(() => {
        let elems, el, el_4, el_2;
        return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12 + "px ",
            flexWrap: "wrap",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Kursmaler",
        })), (el_4 = Button, createElement(el_4, {
            appearance: "primary",
            icon: (el_2 = AddRegular, createElement(el_2, {})),
            children: "Nytt kurs",
            onClick: (_arg_1) => {
                dispatch(new Msg(2, [new CourseDialogMode(0, [])]));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1, el_6, elems_2;
            return append_1((model_1.AllCourses.length === 0) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                padding: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }], (elems_1 = [(el_6 = Body1, createElement(el_6, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: "Ingen kursmaler enda. Klikk «Nytt kurs» for å opprette en.",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "grid",
                gridTemplateColumns: `repeat(auto-fill, minmax(${cardMinWidth}, 1fr))`,
                gap: 16 + "px ",
            }], (elems_2 = toList(delay(() => map_1((course) => createElement(CourseCard, {
                course: course,
                dispatch: dispatch,
            }), sortBy((_arg_2) => _arg_2.Name, model_1.AllCourses, {
                Compare: comparePrimitives,
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append_1(singleton_1(createElement(Dialog_1, {
                mode: unwrap(model_1.DialogMode),
                allTasks: model_1.AllTasks,
                onClose: () => {
                    dispatch(new Msg(3, []));
                },
                onChange: (change) => {
                    dispatch(new Msg(4, [change]));
                },
            })), delay(() => {
                const matchValue = model_1.PendingDelete;
                if (matchValue != null) {
                    const course_1 = matchValue;
                    return singleton_1(createElement(DeleteConfirmDialog, {
                        course: course_1,
                        dispatch: dispatch,
                    }));
                }
                else {
                    return singleton_1(defaultOf());
                }
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

//# sourceMappingURL=EditCourse.jsx.map
